export default __webpack_public_path__ + "static/media/s5.9265ce8e.jpg";